import { useAuthStore } from '@/store/useAuthStore'
import Toast from '@/utils/Toast'
export async function useApiFetch(url, options = {}) {
  const auth = useAuthStore()
  
  url = `https://api.aloh.in/v1${url}`
  
  // Adiciona token se estiver logado
  const headers = {
    ...options.headers,
    Authorization: auth.accessToken ? `Bearer ${auth.accessToken}` : '',
  }
  
  const res = await fetch(url, {
    ...options,
    headers,
  })
  
  // Interceptor de resposta
  if (res.status === 401) {
    auth.logout() // ou redireciona
    throw new Error('Não autorizado')
  }
  
  if (!res.ok) {
    const error = await res.json().catch(() => ({}))
    const errMsg = error.message || error.error || `Erro ao acessar ${url}: ${res.statusText}`
    Toast.error(errMsg);
    throw new Error(errMsg)
  }

  return await res.json()
}
